import React from 'react';
import styled from 'styled-components';

const Wrap = styled.span`
  width: ${({ $size }) => $size || '2.15rem'};
  height: ${({ $size }) => $size || '2.15rem'};
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ $color }) => $color || '#111'};
  filter: ${({ $shadow }) => ($shadow ? 'drop-shadow(0 10px 18px rgba(0, 0, 0, 0.10))' : 'none')};

  svg {
    width: 100%;
    height: 100%;
    overflow: visible;
  }
`;

const PBMark = ({
  size,
  shadow = false,
  className,
  alt = '',
  color = '#111',
}) => (
  <Wrap
    className={className}
    aria-hidden={alt ? undefined : 'true'}
    role={alt ? 'img' : undefined}
    aria-label={alt || undefined}
    $size={size}
    $shadow={shadow}
    $color={color}
  >
    <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text
        x="8"
        y="21"
        fill="currentColor"
        fontFamily='"Manrope", Inter, system-ui, sans-serif'
        fontSize="25"
        fontWeight="800"
        letterSpacing="-2.2"
      >
        P
      </text>
      <text
        x="20"
        y="42"
        fill="currentColor"
        fontFamily='"Manrope", Inter, system-ui, sans-serif'
        fontSize="25"
        fontWeight="800"
        letterSpacing="-2.2"
      >
        B
      </text>
    </svg>
  </Wrap>
);

export default PBMark;
